import {Component, Input, OnInit, ViewChild, ElementRef} from '@angular/core';
import { booleanToYesNo, isDefined, hasBorehole, hasCasing, hasCement } from "../../new-casing-plan/models/casing-plan-functions.model";

import { CasingPlanModel, WellSegmentModel, CasingType } from '../../new-casing-plan/models/casing-plan.model';


@Component({
    selector: 'casing-plan-2d-base',
    template: '',
    standalone: false
})
export class CasingPlan2dBaseComponent implements OnInit {

    @ViewChild('canvas', { static: true }) canvasRef: ElementRef;


    _canvasWidth: number = 750;
    set canvasWidth(value: number) {
        this._canvasWidth = value;
    }
    get canvasWidth(): number {
        return this._canvasWidth;
    }

    dataMissingError: string = "Missing Kick Point and Position Data!";

    canvasHeight: number = 700;
    segmentWidth: number = 20;
    segmentIndex: number = 0;
    shoeHW: number = 20;
    collarH: number = 15;
    basketHW: number = 20;
    packerH: number = 30;
    packerW: number = 15;
    wellSegments: any;
    longestCasing: WellSegmentModel;
    longestCasingIndex: number;
    lengthArray: Array<number> = [];
    totalStringLength: number = 0;                      //Combined length of all strings
    diagramStringLengthsArray: Array<number> = [];
    diagramInfoBoxVerticalOffset: number = 20;
    direction: string;
    infoBoxTopPositions = [390, 315, 236, 175, 115, 63];
    casingPositions: Array<number> = [95, 80, 65, 50, 35, 20, 15]; 
    casingPositionsSchematic: Array<number> = [140, 120, 100, 80, 60, 40, 20]; 
    blackStroke: string =  "#000000";

    internalCasingTypes = [CasingType.Tubing];

    constructor() { }

    ngOnInit(): void {
    }

    //calculate where to place the info box for the segment
    //segment height / 2 (negative margin has been added in the css to account for the height of the box)
    segmentInfoTopPosition(index) {
        //horizontal well segment? 
        if (this.direction == "horizontal" && index == this.wellSegments.length - 1) {
            //move it down a liitle further for the curve
            return this.getCumlativeLength(index + 1) + this.diagramInfoBoxVerticalOffset + 20 + "px";
        } else {
            return this.getCumlativeLength(index + 1) + this.diagramInfoBoxVerticalOffset + "px";
        }
        
    }

    //alternate the info boxes to the left and the right
    //of the segments by adding classes
    segmentInfoLeftRightPosition(index) {
        let ascIndex = index;
        const length = this.wellSegments.length;
        index = (length - index) - 1;

        //let segment = this.wellSegments[ascIndex];
        //is it a production casing on a horizontal well?
        if (this.direction == "horizontal" && ascIndex == this.wellSegments.length - 1) {
            return "segment-left";
        }

        //things are going awry here 
        if(this.isEven(index)) {
            return "segment-right";
        } else {
            return "segment-left";
        }
    }

    segmentHasKickPoint(segment: any):boolean {
        if (segment && segment.gisObjects) {
            for (let gisObject of segment.gisObjects) {
                if (gisObject.point == "Kick Point") {
                    return true;
                }
            }
        }
        return false;
    }

    addSymbols(segment, ctx, rightCasing, leftCasing, casingLength, length): void {
        //does segment have a shoe?
        if(segment.casingShoeDepth && segment.casingShoeDepth > 0) {
            const percentage = segment.casingShoeDepth / segment.casingLength;
            //canvas height should be updated to whatever the length of the casing ends up being
            const y = (casingLength * percentage) - 20;
            
            this.addShoeToCanvas(ctx, y, rightCasing, leftCasing, true);
        }

        //does segment have a packer?
        if(segment.packerDepth && segment.packerDepth > 0) {
            const percentage = segment.packerDepth / segment.casingLength;
            const y = length * percentage;

            this.addPackerToCanvas(ctx, y, rightCasing, leftCasing, true);
        }

        //does segment have basket?
        if(segment.basketDepth && segment.basketDepth > 0) {
            const percentage = segment.basketDepth / segment.casingLength;            
            const y = length * percentage;
            this.addBasketToCanvas(ctx, y, rightCasing, leftCasing, true);
        }

        //does segment have collar?
        if(segment.floatCollarDepth && segment.floatCollarDepth > 0) {
            const percentage = segment.floatCollarDepth / segment.casingLength;
            //canvas height should be updated to whatever the length of the casing ends up being
            const y = length * percentage;


            this.addCollarToCanvas(ctx, y, rightCasing, leftCasing, true);
        }
    }

    //would like to put these all in one function but
    //"onload" doesn't allow for much flexibility
    addPackerToCanvas(ctx: any, length: number, rightCasing: number, leftCasing: number, vertical: boolean, small:boolean = false): void {
        let packer = new Image();

        //scoot right pack to the right a little
        rightCasing += 5;

        //TODO: fix after 3/5 UAT. Small images used for horizontal well & production string 
        packer.onload = ()=> {
            if (vertical) {
                if (small) {
                    ctx.drawImage(packer, rightCasing, length, 8, 20);
                    ctx.drawImage(packer, leftCasing, length, 8, 20);
                } else {
                    ctx.drawImage(packer, rightCasing, length, 15, 30);
                    ctx.drawImage(packer, leftCasing, length, 15, 30);
                }
            } else {
                //image, dx, dy, dWidth, dHeight;
                ctx.drawImage(packer, length, rightCasing, 30, 15);
                ctx.drawImage(packer, length, leftCasing, 30, 15);
            }
        };

        packer.src = vertical ? "../../../assets/images/SVG/packer.svg" : "../../../assets/images/SVG/horizontal-packer.svg";
    }

    addBasketToCanvas(ctx, length: number, rightCasing: number, leftCasing: number, vertical: boolean, small:boolean = false): void {
        let basketLeft = new Image();
        let basketRight = new Image();

        //TODO: fix after 3/5 UAT. Small images used for horizontal well & production string 
        basketLeft.onload = ()=> {
            if (vertical) {
                if (small) {
                    ctx.drawImage(basketLeft, leftCasing - 20, length, 15, 15);
                } else {
                    ctx.drawImage(basketLeft, leftCasing - 20, length, 20, 20);
                }
                
            } else {
                ctx.drawImage(basketLeft, length, leftCasing, 20, 20);
            }
        };

        basketRight.onload = () => {
            if (vertical) {
                if (small) {
                    ctx.drawImage(basketRight, rightCasing, length, 15, 15);
                } else {
                    ctx.drawImage(basketRight, rightCasing, length, 20, 20);
                }
                
            } else {
                ctx.drawImage(basketRight, length, rightCasing, 20, 20);
            }
        };


        basketLeft.src = vertical ? "../../../assets/images/SVG/basket-left.svg" : "../../../assets/images/SVG/horizontal-basket-top.svg";
        basketRight.src = "../../../assets/images/SVG/basket-right.svg";
    }

    addCollarToCanvas(ctx, length: number, rightCasing: number, leftCasing: number, vertical: boolean, small:boolean = false): void {
        let collar = new Image();

        rightCasing -= 5;
        leftCasing -= 5;

        collar.onload = ()=> {
            //TODO: fix after 3/5 UAT. Small images used for horizontal well & production string 
            if (vertical) {
                if (small) {
                    ctx.drawImage(collar, rightCasing, length, 20, 10);
                    ctx.drawImage(collar, leftCasing, length, 20, 10);
                } else {
                    ctx.drawImage(collar, rightCasing, length, 30, 15);
                    ctx.drawImage(collar, leftCasing, length, 30, 15);
                }

            } else {
                ctx.drawImage(collar, length, rightCasing, 15, 30);
                ctx.drawImage(collar, length, leftCasing, 15, 30);
            }
        };

        collar.src = vertical ? "../../../assets/images/SVG/collar-solid.svg" : "../../../assets/images/SVG/horizontal-collar-solid.svg";
    }

    addShoeToCanvas(ctx, length: number, rightCasing: number, leftCasing: number, vertical: boolean): void {
        let shoeLeft = new Image();
        let shoeRight = new Image();

        shoeLeft.onload = ()=> {
            //img, x, y, width, height
            if(vertical) {
                ctx.drawImage(shoeLeft, leftCasing, length, this.shoeHW, this.shoeHW);
            } else {
                ctx.drawImage(shoeLeft, length, leftCasing, this.shoeHW, this.shoeHW);
            }
        };

        shoeRight.onload = ()=> {
            //img, x, y, width, height
            if(vertical) {
                ctx.drawImage(shoeRight, rightCasing, length, 20, 20);
            } else {
                ctx.drawImage(shoeRight, length, rightCasing, 20, 20);
            }
        };

        shoeLeft.src = vertical ? "../../../assets/images/SVG/shoe-left.svg" : "../../../assets/images/SVG/horizontal-shoe-right.svg";
        shoeRight.src = vertical ? "../../../assets/images/SVG/shoe-right.svg" : "../../../assets/images/SVG/horizontal-shoe-left.svg";
    }

    addShoeToCanvas2(ctx, rightCasing: number, leftCasing: number, length: number, vertical: boolean): void {
        let shoeLeft = new Image();
        let shoeRight = new Image();

        shoeLeft.onload = () => {
            //img, x, y, width, height
            if (vertical) {
                ctx.drawImage(shoeLeft, leftCasing, length, this.shoeHW, this.shoeHW);
            } else {
                ctx.drawImage(shoeLeft, length, leftCasing, this.shoeHW, this.shoeHW);
            }
        };

        shoeRight.onload = () => {
            //img, x, y, width, height
            if (vertical) {
                ctx.drawImage(shoeRight, rightCasing, length, 20, 20);
            } else {
                ctx.drawImage(shoeRight, length, rightCasing, 20, 20);
            }
        };

        shoeLeft.src = vertical ? "../../../assets/images/SVG/shoe-left.svg" : "../../../assets/images/SVG/horizontal-shoe-right.svg";
        shoeRight.src = vertical ? "../../../assets/images/SVG/shoe-right.svg" : "../../../assets/images/SVG/horizontal-shoe-left.svg";
    }


    isEven(value) {
        return (value % 2 == 0) ? true : false;
    }

    //these are the fill colors for the segments
    fillColor(index: number) {
        const colors = {
            0: "#c8c8c8",
            1: "#b4b4b4",
            2: "#a0a0a0",
            3: "#8c8c8c",
            4: "#787878",
            5: "#646464",
            6: "#505050"
        };

        return colors[index];
    }

    findLongestCasing() {
        let casingsArray = this.wellSegments.filter(c => this.internalCasingTypes.findIndex(type => type == c.casingType.Definition) == -1).map(casing => {
            if (this.hasCasing(casing)) {
                return casing.casingBottom - casing.casingTop;
            } else if (this.hasBorehole(casing)) {
                return casing.boreholeBottom - casing.boreholeTop;
            }
            return 0;
        });
        

        let longest = Math.max.apply(Math, casingsArray);

        this.wellSegments.forEach((casing, index) => {
            let length = this.hasCasing(casing) ? casing.casingLength : casing.boreholeDepth;
            if(length === longest) {
                this.longestCasingIndex = index;
                this.longestCasing = this.wellSegments[index];
            }
        });

        this.totalStringLength = (this.longestCasing != null) ?  this.longestCasing.casingLength : 0;
    }

    casingNumber(index: number): number {
        return this.wellSegments.length - index;
    }

    //if a segment is short relative to the longest segment
    //we want it to be long enough to be seen
    checkLength(length): number {
        this.lengthArray.push(length);

            this.diagramStringLengthsArray.push(length);
            return length;

    }

    convertBooleanToYesNo(value: boolean): string {
        return booleanToYesNo(value);
    }

    /**
     * Gets cumlative length for vertical positioning
     * @param index
     */
    getCumlativeLength(index:number): number {
        let cumulative = 0;
        for (let i = 0; i <= index; i++) {
            const length = this.diagramStringLengthsArray[i];
            if (length > cumulative) cumulative = length; 
        }
        return cumulative;
    }

    /**
     * Pulls proper casing value from array
     *  Need to pull from last to first based on index
     * @param index
     */
    getCasingPositionValue(index, isSchematic: boolean = false): number {
        if (isSchematic) {
            return this.casingPositionsSchematic[(this.casingPositionsSchematic.length - 1) - (this.wellSegments.length - 1) + index];
        } else {
            return this.casingPositions[(this.casingPositions.length - 1) - (this.wellSegments.length - 1) + index];
        }
        
        
    }

    defined(obj: any): boolean {
        return isDefined(obj);
    }

    /**
     * Provides centralized method for drawing/not drawing shapes, labels and summary text
     * @param value - from segment model property
     * @param type - "string" or "number"
     */
    hasValidValue(value, type): boolean {
        let rv: boolean = false;
        if (value != null) {
            if (type == "string") rv = value !== "";
            else if (type == "number") rv = value.toString() !== "" && value >= 0;
            else if (type == "boolean") rv = value.toString() !== "";
        }
        return rv;
    }

    /**
     * Production string?
     * @param segment
     */
    isProductionString(segment: WellSegmentModel): boolean {
        return segment.casingType.definition == CasingType.Production;
    }

    hasBorehole(segment: WellSegmentModel): boolean {
        return hasBorehole(segment);
    }

    hasCasing(segment: WellSegmentModel): boolean {
        return hasCasing(segment);
    }

    hasCement(segment: WellSegmentModel): boolean {
        return hasCement(segment);
    }

    /**
     * Not production string of horizontal well?
     * @param segment
     */
    isNotHorzontalProduction(segment: WellSegmentModel): boolean {

        if (this.direction == "vertical") return true;

        if (this.direction == "horizontal" && !this.isProductionString(segment)) {
            return true;
        }
        else {
            return false;
        }
    }
}
